import { AuthenticatedUser } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils';

export const authenticate = (): Promise<AuthenticatedUser> => HttpClient.get<AuthenticatedUser>(API_FACTORY.v3('auth/me'));
